import type {
	CustomerQuoteBoardItem,
	QuoteBoardItem,
} from "~/shared/schemas/quote-board-schema.ts";

type QuoteBoardRow = QuoteBoardItem | CustomerQuoteBoardItem;

export const applyBulkTenderFeatureGate = (
	items: QuoteBoardRow[],
	isBulkTenderEnabled: boolean,
): QuoteBoardRow[] => {
	if (isBulkTenderEnabled) return items;

	return items.map((item): QuoteBoardRow => {
		if (item.bulkQuoteId == null || item.isLtlTender !== true) return item;

		return {
			...item,
			bulkTenderReason: null,
			bulkTenderReasonCode: null,
			bulkTenderStatus: null,
			isLtlTender: null,
		};
	});
};
